import {
  ModalContent
} from "./chunk-6TYU4DP7.mjs";
import {
  Modal
} from "./chunk-LBED2F7B.mjs";

// src/alert-dialog.tsx
import { forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
function AlertDialog(props) {
  const { leastDestructiveRef, ...rest } = props;
  return /* @__PURE__ */ jsx(Modal, { ...rest, initialFocusRef: leastDestructiveRef });
}
var AlertDialogContent = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(ModalContent, { ref, role: "alertdialog", ...props })
);

export {
  AlertDialog,
  AlertDialogContent
};
